<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#vitamine2plus">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Vitamine și minerale</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black"></span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black"></span></div>
    </div>

    <div id="vitamine2plus" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina A</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">413 µg-RE</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">59 µg-RE</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina D</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">12 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.7 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina E</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">10 mg TE</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.5 mg TE</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina K</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">40 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">5.8 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina C</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">64 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">9.3 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Tiamină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.71 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.10 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Riboflavină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">1 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.14 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Niacină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.2 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.46 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina B6</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.390 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.056 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Folat</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">94 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">14 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina B12</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">1.2 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.18 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Biotină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">12 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.8 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid pantotenic</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.443 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.496 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Sodiu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">164 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">23.6 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Potasiu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">582 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">84 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Clorură</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">373 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">54 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Calciu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">505 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">73 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fosfor</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">347 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">50 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Magneziu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">47 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">6.8 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fier</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">7.1 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.0 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Cupru</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.373 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.054 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Mangan</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.036 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.005 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Florură*</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">≤0,042 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">≤0,0061 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Seleniu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">22 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">3.1 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Iod</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">92 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">13 µg</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vitamine",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
